import preprocessRange from './preprocessRange';

/**
 * Validates and preprocesses (@link preprocessRange) a range. A range is valid when it is inside a container with the ID {@link containerId}.
 *
 * @param {Range} range - The `Range` object to validate.
 * @param {string} containerId - The ID of the container that should contain the range.
 * @returns {Range | null} The validated `Range` object, or `null` if no valid range was found.
 */
const validateRange = (range: Range, containerId: string): Range | null => {
  const root = document.getElementById(containerId);
  const r = preprocessRange(range, document);

  if (!r) {
    return null;
  }

  // The range is valid, if the root container contains start- AND end container of the range.
  if (root?.contains(r.startContainer) && root?.contains(r.endContainer)) {
    return range;
  }

  return null;
};

/**
 * Gets a `Range` object from a `Selection` object and validates it {@link validateRange}.
 *
 * @param {Selection | null} selection - The `Selection` object generated by the user when marking text with the browser.
 * @param {string} containerId - The ID of the container that should contain the selection.
 * @returns {Range | null} The validated `Range` object, or `null` if no valid range was found.
 */
const getRange = (
  selection: Selection | null,
  containerId: string,
): Range | null => {
  let r;
  if (selection && selection.rangeCount > 0) {
    r = selection.getRangeAt(0);
  }

  return r ? validateRange(r, containerId) : null;
};

export { validateRange, getRange };
